export default __webpack_public_path__ + "static/media/Icon feather-plus-circle.a0fea8f1.svg";